import { render, staticRenderFns } from "./pro-details.vue?vue&type=template&id=09fa95e8&scoped=true"
import script from "./pro-details.vue?vue&type=script&lang=js"
export * from "./pro-details.vue?vue&type=script&lang=js"
import style0 from "./pro-details.vue?vue&type=style&index=0&id=09fa95e8&prod&scoped=true&lang=scss"
import style1 from "./pro-details.vue?vue&type=style&index=1&id=09fa95e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa95e8",
  null
  
)

export default component.exports